import {Component, OnDestroy, OnInit} from '@angular/core';
import {GenericDatatableComponent} from '../../../shared/components/generic-datatable/generic-datatable.component';
import {select} from '@ngrx/store';
import * as fromShipping from '../../../shipping/reducers';
import {SetPreferencesAction} from '../../../shared/actions/preferences';
import {OrderItem} from '../../../order/models/order-item';
import {
  ChangeShippingsPageSizeAction,
  ClearShippingsAction,
  LoadShippingsAction,
  OrderShippingsByAction,
  PageShippingsToAction,
  QuickSearchShippingsAction,
  SearchShippingsAction,
  ToggleSearchShippingsAction
} from '../../actions/shipping-list';
import {ShippingsFilter, ShippingsList} from '../../models/shippings-list';
import * as fromRoot from '../../../shared/reducers';
import * as fromSite from '../../../site/reducers';
import {Site} from '../../../shared/models/site';
import {map, skipWhile} from 'rxjs/operators';

@Component({
  selector: 'storever-shippings-list',
  templateUrl: '../../../shared/components/generic-datatable/generic-datatable.component.html',
  styleUrls: ['../../../shared/components/generic-datatable/generic-datatable.component.scss']
})
export class ShippingsListComponent extends GenericDatatableComponent implements OnInit, OnDestroy {

  private currentSiteName: string;
  dataContext: {context: string, clientId: string, siteId: string, shippingId: string};

  ngOnInit(): void {
    this.dataConfig = this.shippingDataService.getShippingsListData().dataTabs[0].dataConfig;
    super.ngOnInit();
    this.loadDataOnChangeUrl('pickupDate descending', 'shippings_row_size');
    // this.orderByChanged('pickupDate descending');
    this.setCurrentSiteNameIfOnPage();
  }

  ngOnDestroy(): void {
    this.storeShipping.dispatch(new ClearShippingsAction());
    if ( this.dataConfig && this.dataConfig.form ) { this.dataConfig.form.markAsPristine() ; }
    this.router.navigate( [], { queryParams: {}});
  }

  /*
  if page site detail get the site name to bind  ShippingsFilter
  */
  setCurrentSiteNameIfOnPage(): void {
    let init = true;
    if (this.router.url.includes('/sites/detail/') || this.router.url.includes('sites/detail-multi')) {
      this.storeRoot.pipe(
        skipWhile(data => !data),
        select(fromSite.selectors.getSite)
      ).subscribe((site: Site) => {
        if (site && site.displayName && init) {
          this.currentSiteName = site.displayName;
          this.cleandDataConfigForSitePage();
          this.applyFilter({ siteName: site.displayName ,  $orderBy: 'pickupDate descending'});
          init =  false
        }
      });
    }

  }

  loadData(): void {
  //  this.orderByChanged('pickupDate descending');
    this.storeShipping.dispatch(new LoadShippingsAction());
  }

  /* remove from group config the input search and from content for datatable the site name */
  cleandDataConfigForSitePage(): void {
    this.dataConfig.groupConfigs.groupConfigs[0].config.splice(4, 1); // [4].controlName[0]
    this.dataConfig.content.splice(4, 1);
  }

  storeSelect(): void {
    this.pageSize$ = this.storeRoot.pipe(select(fromRoot.selectors.getPreferencesByName, 'shippings_row_size'));
    this.count$ = this.storeShipping.pipe(select(fromShipping.selectors.getShippingCount));
    this.showFilter$ = this.storeShipping.pipe(select(fromShipping.selectors.getShippingShowFilter));
    // if currentSiteName not exist mean you are not in site detail and after that filter on site name
    this.data$ = this.storeShipping.pipe(select(fromShipping.selectors.getShippings)).pipe(
      map(data => data.filter(r => {
        if (!this.currentSiteName || r.siteName === this.currentSiteName) {
          return r;
        }
        return;
      })),
    )
    let pageSizeInit = true ;
    this.sub$ = this.pageSize$.subscribe(pageSize => {
      if ( pageSizeInit && pageSize ) {
      this.storeShipping.dispatch(new ChangeShippingsPageSizeAction(pageSize));
      pageSizeInit = false;
      }
    });
    this.subscriptions.push(this.sub$);
  }

  orderByChanged(orderBy: string): void {
    this.storeShipping.dispatch(new OrderShippingsByAction(orderBy));
  }

  pageSizeChanged(pageSize: number): void {
    if (pageSize === -1) {
      pageSize = 100;
    }
    this.storeShipping.dispatch(new SetPreferencesAction({ name: 'shippings_row_size', value: '' + pageSize }));
    this.storeShipping.dispatch(new ChangeShippingsPageSizeAction(pageSize));
  }

  pageChanged(page: number): void {
    this.storeShipping.dispatch(new PageShippingsToAction(page));
  }

  // tslint:disable-next-line:no-any
  applyFilter(filterForm: any): void {
    let countryCode;
    if (filterForm && filterForm.countryCode && filterForm.countryCode.code) {
      countryCode = filterForm.countryCode.code;
      filterForm.countryCode = countryCode;
    }
    filterForm = this.addSiteNameFilterForm(filterForm);
    this.storeShipping.dispatch(new SearchShippingsAction({
      data: this.filterDeleteIfNilService.flatten(filterForm), fragment: 'Shippings'
    }));
  }

  addSiteNameFilterForm(filterForm: ShippingsFilter): ShippingsFilter {
    if (this.currentSiteName) {
      filterForm = { ...filterForm, ...{ siteName: this.currentSiteName } };
    }
    return filterForm;
  }

  applyQuickFilter(query: string): void {
    this.storeShipping.dispatch(new QuickSearchShippingsAction(query));
  }

  toggleFilter(showFilter: boolean): void {
    this.storeShipping.dispatch(new ToggleSearchShippingsAction(!showFilter));
  }

  dispatchClearDataAction(): void {
    this.storeShipping.dispatch(new ClearShippingsAction());
  }

  dispatchToggleSelected(order: OrderItem): void {
  }

  toggleSelected(order: OrderItem): void {
  }

  routerLink(route: string, data: ShippingsList): {path: string[], fragment?: string} {
    if (route === 'orderItem' && data.orderUuid) {
      return {path: ['/', 'orders', 'detail', data.orderUuid], fragment: null};
    }
    if (route === 'siteName' && data.siteUuid) {
      return {path: ['/', data.clientUuid, 'sites', 'detail', data.siteUuid], fragment: 'Shippings'};
    }
  }

  disablePagination(): boolean {
    return false;
  }

  // tslint:disable-next-line:no-any
  actionButton(type: string, data?: any): void {
    if (this.dataContext) {
      if (this.dataContext && this.dataContext.clientId && this.dataContext.siteId) {
        const clientId = this.dataContext.clientId;
        const siteId = this.dataContext.siteId;
        const shippingId = data ? data.uuid : this.dataContext.shippingId;
        this.shippingsContextService.sendContext({context: 'Shippings-edit', clientId: clientId, siteId: siteId, shippingId: shippingId});
      } else {
        this.router.navigate(['/', 'shippings', 'add']);
      }
    } else if (type === 'shippingItem') {
      this.router.navigate(['./', 'shippings', 'detail', data.uuid], {fragment: null});
    } else if (type === 'openModal') {
      this.router.navigate(['./', 'shippings', 'add'], {fragment: null});
    }
  }


}

